import React, { Component, Fragment } from 'react';
import { Card, Button } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import HistoryReportPdf from './HistoryReportPdfTwo';
import Spinner from 'react-bootstrap/Spinner';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

class HistoryFormTwo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            motivo_consulta: this.props.history.motivo_consulta != null && this.props.history.motivo_consulta != undefined ? this.props.history.motivo_consulta : null,
            descripcion: this.props.history.descripcion != null && this.props.history.descripcion != undefined ? this.props.history.descripcion : null,
            resultados: "",
            recomendaciones: this.props.history.recomendaciones != null && this.props.history.recomendaciones != undefined ? this.props.history.recomendaciones : null,
            procedimiento: "",
            observaciones: this.props.history.observaciones != null && this.props.history.observaciones != undefined ? this.props.history.observaciones : null,
            conlusion: "",
            nota: "",
            interpretacion: this.props.history.descripcion != null && this.props.history.descripcion != undefined ? this.props.history.descripcion : null,
            plans: [],
            planName: '',
            idPlan: '',
            age: '',
            id_informe: "",
            exist: false,
            disableInput: false,
            onUpdate: false,
            loading: true,
            useRecomentarions: true
        }
    }

    componentDidMount() {      
       
        this.getDataHistory();        
    }


    getDataHistory = () => {

        if (this.props.dataHistory.length > 0) {

            const data = this.props.dataHistory;

            for (let i = 0; i < data.length; i++) {
                if (data[i].tipo_informe === 2) {

                    this.setState({
                        loading: false,
                        id_informe: data[i].id_hist_informes,
                        motivo_consulta: data[i].motivo_consulta,
                        recomendaciones: data[i].recomendaciones,
                        descripcion: data[i].resultados,
                        interpretacion: data[i].interpretacion,
                        observaciones: data[i].observacion,
                        exist: true,
                        disableInput: true,
                        useRecomentarions: data[i].recomendaciones === '' ? false : true,
                    });
                }else if((i+1) === data.length){
                    this.setState({ loading: false });
                }
            }
        }else{
            this.setState({ loading: false });
        }    
    }

    makePdf = async () => {

        const dataReport = {
            motivo_consulta: this.state.motivo_consulta,
            recomendaciones: this.state.recomendaciones,
            descripcion: this.state.descripcion,
            observaciones: this.state.observaciones,
            interpretacion: this.state.interpretacion,
            names: this.props.data.nombres,
            direccion: this.props.data.adress.direccion,
            age: this.props.age,//this.state.age,
            plan: this.props.planName, //this.state.planName,
            id_historia: this.props.data.id_historia,
            documentNumber: this.props.data.num_documento,
            telephone: this.props.data.telephone !== null ? this.props.data.telephone : '',
            address: this.props.data.adress.direccion !== null ? this.props.data.adress.direccion: '',
            remitente: this.props.data.remitente,
            fecha: this.props.data.fecha,
            ocupation: this.props.data.ocupacion !== null ? this.props.data.ocupacion :'',
            hora: this.props.data.fecha_ingreso_completa,
            useRecomentarions: this.state.useRecomentarions,

        };

        HistoryReportPdf(dataReport);
    }

    saveData = () => {


        if (this.state.observaciones === '')
            this.setState({ observaciones: this.props.history.observaciones });

        //Descripcion- Interpretacion
        const dataToSend = {
            id_historia: this.props.data.id_historia,
            id_admision: this.props.data.id_admision,
            motivo_consulta: this.state.motivo_consulta,
            procedimiento: this.state.procedimiento,
            parametro_estimulacion: '',
            resultados: this.state.descripcion, // Descripcion
            procedimiento: '',
            interpretacion: this.state.interpretacion,
            observacion: this.state.observaciones,
            recomendaciones: this.state.recomendaciones,
            conclusion: "",
            nota: "",
            fecha: this.props.data.fecha, //moment(new Date(this.props.data.fecha)).format("YYYY-MM-DD"),
            id_servicio: null,
            tipo_informe: 2,
            antecedentes_paciente: null,
            lengua_payne: null,
            observacion2: null,
            mioescanografia: null
        }

        console.log(dataToSend);

        fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-informe/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataToSend)
        })
            .then(response => {
                if (response.status !== 500 && response.status !== 403) {
                    return response.text();
                }
            })
            .then(data => {
                console.log(data);
                this.makePdf().then(() => {
                    //window.location.reload();
                    this.setState({ disableInput: true, exist: true, onUpdate: false });
                });

            })
            .catch((error) => {
                console.error('Error:', error);
                //reject(error)
            });
    }

    updateData = () => {

        //Descripcion - Interpretacion
        const dataToSend = {
            id_hist_informes: this.state.id_informe,
            id_historia: this.props.data.id_historia,
            id_admision: this.props.data.id_admision,
            motivo_consulta: this.state.motivo_consulta,
            procedimiento: '',
            parametro_estimulacion: '',
            resultados: this.state.descripcion, // Descripcion
            procedimiento: '',
            interpretacion: this.state.interpretacion,
            observacion: this.state.observaciones === '' ? this.props.history.observaciones : this.state.observaciones,
            recomendaciones: this.state.useRecomentarions ? this.state.recomendaciones : '',
            conclusion: "",
            nota: "",
            fecha: this.props.data.fecha, //moment(new Date(this.props.data.fecha)).format("YYYY-MM-DD"),
            id_servicio: null,
            tipo_informe: 2,
            antecedentes_paciente: null,
            lengua_payne: null,
            observacion2: null,
            mioescanografia: null

        }


        fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-informe/update', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataToSend)
        })
            .then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.text();
                }
            })
            .then(data => {
                console.log(data);
                this.makePdf().then(() => {
                    //window.location.reload();
                    this.setState({ disableInput: true, exist: true, onUpdate: false });
                });

            })
            .catch((error) => {
                console.error('Error:', error);
                //reject(error)
            });
    }

    render() {

        return (
            <Card>
                {this.state.loading ?
                    <div className="text-center">
                        <Spinner animation="border" variant="success" />
                    </div>
                    :
                    <Fragment>
                        <div className="form" style={{ flex: 1, flexDirection: 'column', display: 'flex' }}>
                            <div className="card__title">
                                <h5 className="bold-text">Resumen De Historia Clinica </h5>
                            </div>

                            <div style={{ flexDirection: 'row', display: 'flex', marginTop: 20 }}>

                                <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label">Motivo de Consulta</span>
                                    <div className="form__form-group-field">
                                        <textarea
                                            name="textarea-motivo-consulta"
                                            value={this.state.motivo_consulta}
                                            onChange={(e) => { this.setState({ motivo_consulta: e.target.value }) }}
                                            disabled={this.state.disableInput}
                                        >
                                        </textarea>
                                    </div>
                                </div>

                                <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label">Descripción </span>
                                    <div className="form__form-group-field">
                                        <textarea
                                            name="textarea-procedimiento"
                                            value={this.state.descripcion}
                                            onChange={(e) => { this.setState({ descripcion: e.target.value }) }}
                                            disabled={this.state.disableInput}
                                        >
                                        </textarea>
                                    </div>
                                </div>
                            </div>

                            <div style={{ flexDirection: 'row', display: 'flex', marginTop: 20 }}>
                                <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label">Interpretación</span>
                                    <div className="form__form-group-field">

                                        <textarea
                                            name="textarea-interpretacion"
                                            value={this.state.interpretacion}
                                            onChange={(e) => { this.setState({ interpretacion: e.target.value }) }}
                                            disabled={this.state.disableInput}
                                        >
                                        </textarea>
                                    </div>
                                </div>

                                <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label">Recomendaciones </span>
                                    <div className="form__form-group-field">

                                        <textarea
                                            name="textarea-conclusion"
                                            value={this.state.recomendaciones}
                                            onChange={(e) => { this.setState({ recomendaciones: e.target.value }) }}
                                            disabled={this.state.disableInput || !this.state.useRecomentarions} 
                                        >
                                        </textarea>
                                    </div>
                                    <FormControlLabel control={<Checkbox name="checkedG" color="primary"

                                        onChange={
                                            (event) => {

                                                if (event.target.checked) {
                                                    this.setState({ useRecomentarions: false,recomendaciones: null });
                                                }
                                                else {
                                                    this.setState({ useRecomentarions: true});
                                                }

                                            }
                                        } />} label="Sin Recomendaciones" />
                                </div>
                            </div>
                            <div style={{ flexDirection: 'row', display: 'flex', marginTop: 20 }}>
                                <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label"> Observaciones</span>
                                    <div className="form__form-group-field">

                                        <textarea
                                            name="textarea-observacion"
                                            value={this.state.observaciones}
                                            onChange={(e) => { this.setState({ observaciones: e.target.value }) }}
                                            disabled={this.state.disableInput}>
                                        </textarea>
                                    </div>
                                </div>

                            </div>
                            <div>
                                <Button
                                    style={{ marginRight: 12, marginTop: 20 }}
                                    size="sm"
                                    color="primary"
                                    onClick={() => {

                                        if (this.state.exist)
                                            this.makePdf();
                                        else
                                            this.saveData();
                                        ///this.generteReportPdf();
                                    }}
                                >
                                    {this.state.exist ? " Generar Reporte" : " Guardar y Generar Reporte"}

                                </Button>

                                {this.state.exist ?
                                    <Button
                                        style={{ marginTop: 20 }}
                                        size="sm"
                                        color="primary"
                                        onClick={() => {

                                            if (this.state.onUpdate)
                                                this.updateData();
                                            else
                                                this.setState({ disableInput: false, onUpdate: true });
                                        }}
                                    >
                                        {this.state.onUpdate ? "Actualizar" : " Habilitar Actualizacion"}
                                    </Button>
                                    : null}
                            </div>

                        </div>
                    </Fragment>}
            </Card>
        );
    }
}

export default reduxForm({
    form: 'history_form_two', // a unique identifier for this form
})(withTranslation('common')(HistoryFormTwo));